import script from "./LlRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./LlRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./LlRadioGroup.vue?vue&type=style&index=0&id=2cc7504e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc7504e"]])

export default __exports__